<template>
    <preparelessonsModule :select_list="select_list" :savaData="savaData" :module_list="module_list" @handleClick="handleClick" :courseInfos="courseInfos" :courseTempList="courseTempList"
                               :searchInput='searchInput' @handleList="handleList" :chapterIndex="chapterIndex" :nodeIndex="nodeIndex" :updateTempList="updateTempList" @handleShowResourse="handleShowResourse" :showResourseList="showResourseList" :showPeitao="showPeitao" @handlegetPeitao="handlegetPeitao" />
</template>

<script>
    import preparelessonsModule from './../../components/teacherCourse/preparelessonsModule.vue'

    export default {
        name: "teacherMatingDetail",
        props: ['courseInfos', 'nodeIndex', 'chapterIndex', 'select_list', 'module_list', 'searchInput', 'courseTempList','showResourseList','showPeitao'],
        components: {
            preparelessonsModule
        },
        methods: {
            handleClick(val) {
                this.$emit('handleSave', true)
            },
            handleList(val) {
                this.$emit('handleList', val)
            },
            savaId(val){
                this.$emit('savaId',val)
           },
            updateTempList(){
              this.$emit('updateTempList');
            },
          savaData(obj){
              this.$emit('savaData',obj)
          },
          handleShowResourse(val){
            console.log("传过来的",val);
            this.$emit('handleShowResourse', val)
          },
          handlegetPeitao(val){
            this.$emit('handlegetPeitao', val)
          }
        }
    }
</script>

<style scoped>

</style>